export type VariantPrice = {
  arena_variant_id: string
  created_at: string
  currency: {
    code: string
    coins_per_currency: number
    id: 'string '
    name: string
    symbol: string
  }
  currency_id: string
  gross_price: string
  id: string
  net_price: 'string'
  updated_at: string
}

export interface VariantInterface {
  id: bigint
  name: string
  active: boolean
  description: string
  image: string
  price: number
  prices: VariantPrice[]
  cost: number
  stock: number
  sku: string
  category_attributes: Array<object>
  inventory_attributes: Array<object>
  custom_attributes: Array<object>
}

export class VariantDTO implements VariantInterface {
  id = 0n
  type = {}
  name = ''
  active = false
  description = ''
  image = ''
  price = 0
  cost = 0
  stock = 0
  sku = ''
  prices = []
  category_attributes = []
  inventory_attributes = []
  custom_attributes = []
}

export default class Variant extends VariantDTO {
  constructor(DTO: VariantDTO) {
    super()
    Object.assign(this, DTO)
  }
}
